/**
 * Application identity.
 *
 * One place, so the name and company can never drift between screens.
 * Phase 0 §1: the interface says "LiftX"; "iNsaneX Tech" appears only in
 * About, Settings, metadata and legal contexts — never in the workout UI.
 */

export const APP_NAME = 'LiftX';
export const COMPANY_NAME = 'iNsaneX Tech';

/** Injected at build time from package.json — see vite.config.ts `define`. */
export const APP_VERSION: string = __APP_VERSION__;
